export { Rating as default } from './Rating';
